//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchBox from "@/components/SearchBox.vue";
import Pages from "@/components/nav_common/CommonPages.vue";
import XczFooter from "@/components/footer/footer.vue";
import PoetryRight from "@/components/nav_poetry/PoetryRight.vue";
import PoetryClassList from "@/components/nav_poetry/PoetryClassList.vue";
import PoetryListItem from "@/components/nav_poetry/PoetryListItem.vue";
import { User, Work } from "@/models";
import { mapGetters, mapActions } from "vuex";
import Market from "@/components/Market.vue";

export default {
  data() {
    return {
      title: "作品 - 中华诗词库",
      description: "百万诗词作品和内容创作",
      keyword: "",
      poems: null,
      page: 1,
      perPage: 20,
      allPage: 333,

      haveUpdateLikeWorks: false
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: null,
      meta: [
        {
          name: "description",
          content: this.description
        }
      ]
    };
  },
  methods: {
    clickLikeBtn(work) {
      (work.liked ? Work.unlike(work.id) : Work.like(work.id)).then(result => {
        work.liked = !work.liked;

        User.getAllLikedWorks().then(works => {
          // console.log('success and the work is ', works)
          this.$store.commit("setLikeWorks", works);
          this.poems.forEach(mem => {
            mem.liked =
              this.likeWorks.findIndex(works => works.id == mem.id) > -1;
          });
        });
      });
    },

    ManipulationData(poems) {
      if (this.user) {
        if (this.likeWorks && this.likeWorks.length > 0) {
          // console.log('重新刷新')
          // console.log(this.likeWorks)
          this.haveUpdateLikeWorks = true;
          poems.forEach(mem => {
            mem.liked =
              this.likeWorks.findIndex(works => works.id == mem.id) > -1;
          });
        } else {
          poems.forEach(mem => {
            mem.liked = false;
          });

          console.error("likeworks is not exist");
        }
      } else {
        this.haveUpdateLikeWorks = false;
        console.error("user is not exist");
      }

      this.poems = poems;
    },

    getCount(count) {
      this.allPage = count;
    },

    search: function() {
      if (this.keyword == "") {
        return;
      }

      this.$router.push({ name: "search", query: { q: this.keyword } });
    },

    changePage: function(value) {
      this.page = value;
    },

    ...mapActions(["loadBanner"])
  },

  computed: {
    ...mapGetters(["likeWorks", "user", "banner"])
  },

  components: {
    SearchBox,
    Pages,
    XczFooter,
    PoetryClassList,
    PoetryRight,
    PoetryListItem,
    Market
  },

  beforeCreate() {
    this.$initWechat().then(() => {
      this.$initWechatShare({
        title: this.title,
        link: location.href,
        image: "http://bigfile.xichuangzhu.com/logo.png",
        desc: this.description
      });
    });
  },

  created() {
    this.loadBanner();

    if (this.user) {
      if (!this.likeWorks || this.likeWorks.length < 1) {
        User.getAllLikedWorks().then(works => {
          // console.log('success and the work is ', works)
          this.$store.commit("setLikeWorks", works);
          if (!this.haveUpdateLikeWorks) {
            // console.log('running created fill likeworks')
            this.poems.forEach(mem => {
              mem.liked =
                this.likeWorks.findIndex(works => works.id == mem.id) > -1;
            });
          }
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/NavPoetry.vue